document.addEventListener("DOMContentLoaded", function() {
    var swiper = new Swiper('.shop-review-slider', {
        spaceBetween: 7,
        slidesPerView: 1,
        centeredSlides: false,
        loop: true,
        pagination: {
            el: '.swiper-pagination',
            clickable: true,
        },
    });
    // const items1 = document.querySelectorAll(".accordionItem");

    // items1.forEach((item1) => {
    //     const title = item1.querySelector(".acc-title");
    //     const content = item1.querySelector(".acc-content");

    //     title.addEventListener("click", () => {

    //         // Close other accordions
    //         item1s1.forEach((other) => {
    //             if (other !== item1) {
    //                 other.classList.remove("open");
    //                 other.classList.add("close");

    //                 const otherContent = other.querySelector(".acc-content");
    //                 otherContent.style.maxHeight = null;
    //             }
    //         });

    //         if (item1.classList.contains("open")) {
    //             item1.classList.remove("open");
    //             item1.classList.add("close");
    //             content.style.maxHeight = null;
    //         } else {
    //             item1.classList.remove("close");
    //             item1.classList.add("open");
    //             content.style.maxHeight = content.scrollHeight + "px";
    //         }
    //     });
    // });

  const accordion = document.querySelector(".shop-acc-v2");
  if (!accordion) return;
  const items = accordion.querySelectorAll(".shop-acc-v2__item");
  items.forEach((item) => {
    const title = item.querySelector(".shop-acc-v2__title");
    const content = item.querySelector(".shop-acc-v2__content");
    if (!title || !content) return;
    title.addEventListener("click", function () {
      const isOpen = item.classList.contains("is-open");
      items.forEach((otherItem) => {
        if (otherItem !== item) {
          otherItem.classList.remove("is-open");
          const otherTitle = otherItem.querySelector(".shop-acc-v2__title");
          const otherContent = otherItem.querySelector(".shop-acc-v2__content");
          if (otherContent) {
            otherContent.style.maxHeight = null;
          }
          if (otherTitle) {
            otherTitle.setAttribute("aria-expanded", "false");
          }
        }
      });

      if (isOpen) {
        item.classList.remove("is-open");
        content.style.maxHeight = null;
        title.setAttribute("aria-expanded", "false");
      } else {
        item.classList.add("is-open");
        content.style.maxHeight = content.scrollHeight + "px";
        title.setAttribute("aria-expanded", "true");
      }
    });
  });

  window.addEventListener("resize", function () {
    const openItem = accordion.querySelector(".shop-acc-v2__item.is-open");

    if (openItem) {
      const content = openItem.querySelector(".shop-acc-v2__content");

      if (content) {
        content.style.maxHeight = content.scrollHeight + "px";
      }
    }
  });
});


/*document.addEventListener('DOMContentLoaded', function () {
  const quantityInput = document.querySelector('.quantity__input, .sticky-action .sticky-qty input');
  const comparePriceEl = document.querySelectorAll('.pdp-compare-price');
  const promoPriceEl = document.querySelectorAll('.pdp-price');

  if (!quantityInput || !comparePriceEl || !promoPriceEl) return;

  const parsePrice = (value) => {
    return parseFloat(value.replace(/[^0-9.-]+/g, '')) || 0;
  };

  const baseRegularPrice = parsePrice(comparePriceEl.textContent);
  const basePromoPrice = parsePrice(promoPriceEl.textContent);

  function updateCTA() {
    const quantity = Math.max(
      1,
      parseInt(quantityInput.value, 10) || 1
    );

    quantityInput.value = quantity;

    comparePriceEl.textContent =
      `$${(baseRegularPrice * quantity).toFixed(2)}`;

    promoPriceEl.textContent =
      `$${(basePromoPrice * quantity).toFixed(2)}`;
  }

  document.querySelectorAll('.quantity__button, .sticky-qty button').forEach((button) => {
    button.addEventListener('click', () => {
      setTimeout(updateCTA, 0);
    });
  });

  quantityInput.addEventListener('input', updateCTA);
  quantityInput.addEventListener('change', updateCTA);

  updateCTA();
}); */

document.addEventListener('DOMContentLoaded', function () {
  const quantityInputs = document.querySelectorAll('.quantity__input');
  const comparePriceEls = document.querySelectorAll('.pdp-compare-price');
  const promoPriceEls = document.querySelectorAll('.pdp-price');

  if (
    !quantityInputs.length ||
    !comparePriceEls.length ||
    !promoPriceEls.length
  ) {
    return;
  }

  const parsePrice = (value) => {
    return parseFloat(String(value).replace(/[^0-9.-]+/g, '')) || 0;
  };

  // Get original single-unit prices
  const baseRegularPrice = parsePrice(comparePriceEls[0].textContent);
  const basePromoPrice = parsePrice(promoPriceEls[0].textContent);

  function updateCTA(quantity) {
    quantity = Math.max(
      1,
      parseInt(quantity, 10) || 1
    );

    // Keep all quantity inputs synchronized
    quantityInputs.forEach((input) => {
      input.value = quantity;
    });

    const totalRegularPrice = baseRegularPrice * quantity;
    const totalPromoPrice = basePromoPrice * quantity;

    // Update compare prices
    comparePriceEls.forEach((el) => {
      el.textContent = `$${totalRegularPrice.toFixed(2)}`;
    });

    // Update promo prices
    promoPriceEls.forEach((el) => {
      el.textContent = `$${totalPromoPrice.toFixed(2)}`;
    });
  }

  // Quantity input changes
  quantityInputs.forEach((input) => {
    input.addEventListener('input', function () {
      updateCTA(this.value);
    });

    input.addEventListener('change', function () {
      updateCTA(this.value);
    });
  });

  // Quantity +/- buttons
  document
    .querySelectorAll('.quantity__button, .sticky-qty button')
    .forEach((button) => {
      button.addEventListener('click', function () {
        setTimeout(() => {
          // Find the quantity input associated with the button
          const quantityInput = this
            .closest('.quantity, .sticky-qty')
            ?.querySelector('.quantity__input, input');

          if (quantityInput) {
            updateCTA(quantityInput.value);
          } else {
            updateCTA(quantityInputs[0].value);
          }
        }, 0);
      });
    });

  // Initial calculation
  updateCTA(quantityInputs[0].value);
});
